import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "border-bottom mb-3" }
const _hoisted_2 = { class: "mb-3 row" }
const _hoisted_3 = { class: "col-sm-9" }
const _hoisted_4 = { class: "mb-3 row" }
const _hoisted_5 = { class: "col-sm-9" }
const _hoisted_6 = ["error"]
const _hoisted_7 = { class: "mb-3 row" }
const _hoisted_8 = { class: "col-sm-9" }
const _hoisted_9 = { class: "border-bottom mb-3" }
const _hoisted_10 = { class: "mb-3 row" }
const _hoisted_11 = { class: "col-sm-9" }
const _hoisted_12 = { class: "document-templates-grid" }
const _hoisted_13 = ["href"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 3 }

import {ref, reactive, computed} from "vue";
import BGrid from "./BGrid/BGrid.vue";
import type {BTableColumn} from "./BTable/BTable.types";
import InformationModal from "./Misc/InformationModal.vue";
import SystemAlerts from "./Misc/SystemAlerts.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import type {DocumentTemplate, DocumentTemplateUpdateRequest} from "../audit.types";
import {useFormValidation} from "../validation";
import TextInput from "./Fields/TextInput.vue";
import FileInput from "./Fields/FileInput.vue";
import {useAuditDocumentTemplateStore} from "@/stores/auditDocumentTemplateStore";
import {object, string, date, mixed} from "yup";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuditDocumentTemplates',
  props: {
    title: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props;

const documentTemplate = ref<DocumentTemplate>({} as DocumentTemplate);
const isShowCreateEditor = ref(false);
const auditDocumentTemplateStore = useAuditDocumentTemplateStore();

const schema = object<DocumentTemplate>({
    name: string().required().max(50).label("Name"),
    description: string().nullable().max(500).label("Description"),
    file: mixed().required().label("File"),
});

const columns = reactive<BTableColumn[]>([
    {
        key: "name",
        text: "Name",
        sortable: true,
        columnClass: ["align-top"],
        value: (item) => item["name"],
    },
    {
        key: "description",
        text: "Description",
        sortable: true,
        columnClass: ["align-top"],
        value: (item) => item["description"],
    },
    {
        key: "UpdatedBy",
        text: "Updated By",
        sortable: true,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.updatedBy,
    },
    {
        key: "UpdatedOn",
        text: "Updated Date",
        sortable: true,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.updatedOn,
    },
    {
        key: "actions",
        text: "",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap text-end"],
        value: (item) => item["link"],
    },
]);

const showCreateEditor = () => {
    resetValidation();
    documentTemplate.value = {} as DocumentTemplate;
    isShowCreateEditor.value = true;
};
const hideCreateEditor = () => {
    isShowCreateEditor.value = false;
};

const getData = async () => {
    await auditDocumentTemplateStore.list();
};

const canAdd = computed(() => props.createAudits);

const canDelete = (): boolean => props.runAudits;

const isShowDeleteDialog = ref(false);
const selectedId = ref(0);

const hideDeleteConfirmEditor = async function () {
    isShowDeleteDialog.value = false;
};

const deleteDocument = async () => {
    await auditDocumentTemplateStore.deleteItem(selectedId.value);
    hideDeleteConfirmEditor();
    getData();
};

const deleteDocumentConfirm = async (id: number) => {
    selectedId.value = id;
    isShowDeleteDialog.value = true;
};

const isShowReplaceDocument = ref(false);

const replaceDocumentSchema = object<DocumentTemplate>({
    file: mixed().required().label("File"),
});
const replaceDocument = ref<DocumentTemplateUpdateRequest>({} as DocumentTemplateUpdateRequest);
const hideReplaceDocument = async () => {
    isShowReplaceDocument.value = false;
};
const showReplaceDocument = async (id: number) => {
    resetValidation();
    replaceDocument.value = {} as DocumentTemplateUpdateRequest;
    isShowReplaceDocument.value = true;
    replaceDocument.value.id = id;
};

const replaceDocumentTemplate = async () => {
    if (await handleSubmit(replaceDocumentSchema, replaceDocument.value)) {
        await auditDocumentTemplateStore.replace(replaceDocument.value);
        await getData();
        await hideReplaceDocument();
    }
};

const {handleSubmit, errors, resetValidation} = useFormValidation();

const createDocumentTemplate = async () => {
    if (await handleSubmit(schema, documentTemplate.value)) {
        await auditDocumentTemplateStore.create(documentTemplate.value);
        await getData();
        await hideCreateEditor();
        documentTemplate.value = {} as DocumentTemplate;
    }
};
;(
  ([__temp,__restore] = _withAsyncContext(() => getData())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InformationModal, {
      title: "Delete",
      key: "confirmDialog",
      ref: "confirmDialog",
      "show-modal": isShowDeleteDialog.value,
      "show-footer": true,
      className: "confirm",
      onDismiss: hideDeleteConfirmEditor
    }, {
      footer: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          "data-bs-dismiss": "modal"
        }, " No ", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _withModifiers(deleteDocument, ["prevent"])
        }, " Yes ")
      ]),
      default: _withCtx(() => [
        _cache[5] || (_cache[5] = _createTextVNode(" Are You Sure? ", -1))
      ]),
      _: 1,
      __: [5]
    }, 8, ["show-modal"]),
    _createVNode(InformationModal, {
      title: "Create Document Template",
      "show-modal": isShowCreateEditor.value,
      ref: "createDialog",
      onDismiss: hideCreateEditor
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(createDocumentTemplate, ["prevent"])
        }, [
          _createElementVNode("fieldset", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[6] || (_cache[6] = _createElementVNode("label", {
                for: "documentTemplateName",
                class: "col-sm-3 col-form-label"
              }, " Name:", -1)),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(TextInput, {
                  id: "documentTemplateName",
                  name: "documentTemplateName",
                  type: "text",
                  modelValue: documentTemplate.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((documentTemplate.value.name) = $event)),
                  error: _unref(errors).name
                }, null, 8, ["modelValue", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[7] || (_cache[7] = _createElementVNode("label", {
                for: "documentTemplateDescription",
                class: "col-sm-3 col-form-label"
              }, "Description:", -1)),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control",
                  id: "documentTemplateDescription",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((documentTemplate.value.description) = $event)),
                  error: _unref(errors).description
                }, null, 8, _hoisted_6), [
                  [_vModelText, documentTemplate.value.description]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                for: "documentTemplateFile",
                class: "col-sm-3 col-form-label"
              }, "File:", -1)),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(FileInput, {
                  modelValue: documentTemplate.value.file,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((documentTemplate.value.file) = $event)),
                  name: "documentTemplateFile",
                  error: _unref(errors).file
                }, null, 8, ["modelValue", "error"])
              ])
            ])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Cancel "),
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "submit"
            }, " Save ")
          ], -1))
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(InformationModal, {
      title: "Replace Document",
      "show-modal": isShowReplaceDocument.value,
      ref: "createDialog",
      onDismiss: hideReplaceDocument
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(replaceDocumentTemplate, ["prevent"])
        }, [
          _createElementVNode("fieldset", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[10] || (_cache[10] = _createElementVNode("label", {
                for: "replaceDocumentTemplateFile",
                class: "col-sm-3 col-form-label"
              }, "File:", -1)),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(FileInput, {
                  modelValue: replaceDocument.value.file,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((replaceDocument.value.file) = $event)),
                  name: "replaceDocumentTemplateFile",
                  error: _unref(errors).file
                }, null, 8, ["modelValue", "error"])
              ])
            ])
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Cancel "),
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "submit"
            }, " Save ")
          ], -1))
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(SystemAlerts),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(BGrid, {
        caption: "List of document templates",
        tableOptions: _unref(auditDocumentTemplateStore).tableOptions,
        filterableFields: _unref(auditDocumentTemplateStore).filterableFields,
        filterOptions: _unref(auditDocumentTemplateStore).filterOptions,
        onOptionChange: getData,
        items: _unref(auditDocumentTemplateStore).items,
        columns: columns,
        loading: _unref(auditDocumentTemplateStore).loading
      }, {
        beforeFilter: _withCtx(() => [
          (canAdd.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _withModifiers(showCreateEditor, ["prevent"]),
                class: "btn btn-primary"
              }, " Create Document Template "))
            : _createCommentVNode("", true)
        ]),
        "cell.actions": _withCtx(({item}) => [
          (item.fileId)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "btn btn-sm btn-secondary me-2",
                href: `api/v1/audit/file/${item.fileId}`
              }, "View Document", 8, _hoisted_13))
            : _createCommentVNode("", true),
          canDelete
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _withModifiers(($event: any) => (showReplaceDocument(item.id)), ["prevent"]),
                "aria-label": "Replace Document",
                type: "button",
                class: "btn btn-sm btn-primary me-2"
              }, " Edit ", 8, _hoisted_14))
            : _createCommentVNode("", true),
          canDelete
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                onClick: _withModifiers(($event: any) => (deleteDocumentConfirm(item.id)), ["prevent"]),
                type: "button",
                class: "btn btn-sm btn-danger"
              }, " Delete ", 8, _hoisted_15))
            : (_openBlock(), _createElementBlock("span", _hoisted_16))
        ]),
        _: 1
      }, 8, ["tableOptions", "filterableFields", "filterOptions", "items", "columns", "loading"])
    ])
  ], 64))
}
}

})